import { SursaSnapshotPanel } from "../components/SursaSnapshotPanel";

export default function FirmeOnrc() {
  return (
    <SursaSnapshotPanel
      sursa="onrc"
      descriere={
        <>
          Exportul lunar ONRC de pe data.gov.ro („Firme înregistrate la
          Registrul Comerțului”): firma, adresa, codurile CAEN autorizate,
          stările și reprezentanții legali. Aplicarea recalculează diferențele
          pe CUI față de starea curentă, marchează firmele ieșite din funcțiune
          ca inactive și scrie istoricul modificărilor.
        </>
      }
      comandaScript={
        'python -m scripts.actualizare.actualizare onrc --proiect dev --sursa "../FIRME SEPT 26"'
      }
    />
  );
}
